const deleteGuide = guideRef => {
  return guideRef
    .delete()
}

export default deleteGuide
